import { render, staticRenderFns } from "./CpDetail.vue?vue&type=template&id=23fab828&scoped=true&"
import script from "./CpDetail.vue?vue&type=script&lang=js&"
export * from "./CpDetail.vue?vue&type=script&lang=js&"
import style0 from "./CpDetail.vue?vue&type=style&index=0&id=23fab828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fab828",
  null
  
)

export default component.exports